import React from "react";
import Parse from 'html-react-parser';
//components
import { MessageItemSentBionexo } from "../MessageItemSentBionexo";
import { IsNullOrEmpty } from "utils/StringNullOrEmpty";
import { Visibility } from "components/Visibility";
import MessageBox from "../MessageBox";
//interfaces
import { IErrorMessages } from "./interface";
//context
import { useDetailsQuoteContext } from "contexts/DetailsQuote";
//assets
import autoAnswerColoredIcon from 'img/AutoresponderIcon.svg';
import { IconWarningItem } from 'img/warning-item';
import { ErrorMessagesContainer } from "./styles";

export const ErrorMessages: React.FC<IErrorMessages> = (props) => {
  const {
    integrationMessages,
    errorMessageVisible,
    distributionCenterSelected,
    origin
  } = props;

  const { quoteDetail } = useDetailsQuoteContext();

  const textAlertItemBionexo = Parse(`Os CD's indicados possuem itens que foram respondidos diretamente na ${origin}. Acesse a ${origin} para ver quais itens foram respondidos.`);

  const previouslyAddedToBionexo = quoteDetail?.distributionCentersList?.find((message) => message.distributionCenter === distributionCenterSelected);

  return (
    <ErrorMessagesContainer>
      <Visibility visible={!IsNullOrEmpty(quoteDetail?.reasonUnanswered)}>
        <MessageBox
          icon={<img src={autoAnswerColoredIcon} alt="Auto Answer colored icon" />}
          message={quoteDetail?.reasonUnanswered && Parse(quoteDetail?.reasonUnanswered!)}
          backgroundColor='#F3E0FF'
          color='#AD36F5'
          borderColor='#AD36F5'
        />
      </Visibility>
      <Visibility visible={!!errorMessageVisible}>
        <MessageBox
          icon={<IconWarningItem color={"#E02828"} width={16} height={16} />}
          boxTitle={`Erro ${origin}!`}
          message={integrationMessages?.message ?? quoteDetail?.supplierStatusMessage}
          backgroundColor='#FFE3E3'
          color='#E02828'
          borderColor='#E02828'
        />
      </Visibility>
      <Visibility visible={previouslyAddedToBionexo?.previouslyAddedToBionexo ?? false}>
        <MessageItemSentBionexo
          sizeText={14}
          colorText="#E02828"
          borderColor="#E02828"
          backgroundColor="#FFE3E3"
          text={textAlertItemBionexo}
          icon={<IconWarningItem color={"#E02828"} width={16} height={16} />}
        />
      </Visibility>
    </ErrorMessagesContainer>
  );
};